import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

/**
 * Generated class for the ProductViewNamePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-delibery-note-view-info',
    templateUrl: 'delibery-note-view-info.html',
})
export class DeliberyNoteViewInfoPage {
    @Input() proding: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {

    }

    /*edit() {
        this.navCtrl.push(DeliberyNoteCreateSelectProviderPage, {
            update_state: true,
            delibery_note_uid: this.proding.UID,
            provider_static: this.proding.uid_provider +',;,'+this.proding.provider_static,
            date: this.proding.date,
            number: this.proding.number,
        })
    }*/

}



// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-view/delibery-note-view-info/delibery-note-view-info.ts